export default __webpack_public_path__ + "static/media/hex-left.6b73439e.svg";